import { useCustomFetchForKeycloakCalls } from '~/composables/useCustomFetch';

export async function getUser(userName: string): Promise<any> {
  const url = `${useMsUrls().keyCloakBaseUrl}/users?search=${userName}&exact=true&max=1`;
  try {
    return await useCustomFetchForKeycloakCalls(url);
  } catch {
    console.error('Error fetching User ID info');
    return Promise.resolve({});
  }
}

export async function getGroup(groupName: string): Promise<any> {
  const url = `${useMsUrls().keyCloakBaseUrl}/groups?exact=true&max=1&search=${groupName}`;
  try {
    return await useCustomFetchForKeycloakCalls(url);
  } catch {
    console.error('Error fetching Florist group info');
    return Promise.resolve({});
  }
}

export async function getGroupMembers(groupId: string): Promise<any> {
  const url = `${useMsUrls().keyCloakBaseUrl}/groups/${groupId}/members`;
  try {
    return await useCustomFetchForKeycloakCalls(url);
  } catch {
    console.error('Error fetching Florist group members info');
    return Promise.resolve({});
  }
}

export async function postImpersonation(userId: string): Promise<any> {
  const url = `${useMsUrls().keyCloakBaseUrl}/users/${userId}/impersonation`;
  try {
    return await useCustomFetchForKeycloakCalls(url);
  } catch {
    console.error('Error fetching Florist group members info');
    return Promise.resolve({});
  }
}

export async function getUserTest(userId: string): Promise<any> {
  const url = `${useMsUrls().keyCloakBaseUrl}/users/${userId}/groups?first=0&max=11`;
  try {
    return await useCustomFetchForKeycloakCalls(url);
  } catch {
    console.error('Error fetching Florist group members info');
    return Promise.resolve({});
  }
}
